import React, { FunctionComponent } from "react";
import { IIconProps } from "./icon";

export const NutritionIcon: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  return (
    <svg width="52px" height="52px" viewBox="0 0 52 52" version="1.1" {...rest}>
      <g
        id="Symbols-Nutrition"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="NutritionIcon" stroke={color} strokeWidth="3">
          <g id="Group" transform="translate(3.458000, 5.187000)">
            <path d="M21.18025,31.7709398 L14.7253167,25.0457061 C13.567059,23.8826674 13.282699,22.1090737 14.0193083,20.6422313 L14.0193083,20.6422313 C14.5672586,19.5453543 15.6093213,18.7789603 16.8196401,18.5827032 C18.029959,18.386446 19.2608051,18.7842805 20.127289,19.6518024 L21.18025,20.7047634 L22.233211,19.6518024 C23.0996949,18.7842805 24.330541,18.386446 25.5408599,18.5827032 C26.7511787,18.7789603 27.7932414,19.5453543 28.3411917,20.6422313 L28.3411917,20.6422313 C29.0757455,22.1107557 28.7881005,23.8845666 27.6271147,25.0457061 L21.18025,31.7709398 Z" />
            <line x1="3.02575" y1="15.1293148" x2="3.02575" y2="42.3610648" />
            <path
              d="M37.5996985,27.2323148 L42.144375,27.2323148 C42.9783398,27.2323177 43.6550261,26.557436 43.65725,25.7234741 C43.6733873,17.9957086 43.7137307,8.66227845 40.5124872,0.934512949 C40.2364299,0.267457555 39.5275263,-0.111612183 38.8194736,0.0292132764 C38.1114208,0.170038735 37.6015177,0.791518417 37.6017157,1.51343978 L37.6017157,42.3610648"
              transform="translate(40.629808, 21.180532) scale(-1, 1) translate(-40.629808, -21.180532) "
            />
            <path d="M0,0.000564782208 L0,12.1035648 C0,13.7746404 1.35467442,15.1293148 3.02575,15.1293148 L3.02575,15.1293148 C4.69682558,15.1293148 6.0515,13.7746404 6.0515,12.1035648 L6.0515,0.000564782208" />
            <path d="M31.770375,14.2518473 C29.0323385,11.3134892 25.1965657,9.64480602 21.18025,9.64480602 C17.1639343,9.64480602 13.3281615,11.3134892 10.590125,14.2518473" />
            <path d="M10.590125,34.1612823 C13.3281615,37.0996404 17.1639343,38.7683235 21.18025,38.7683235 C25.1965657,38.7683235 29.0323385,37.0996404 31.770375,34.1612823" />
          </g>
        </g>
      </g>
    </svg>
  );
};
